import { useLinkOnSameProject } from '@monorepo/shared/hooks/navigation/useLinkOnSame/useLinkOnSameProject';

export function useAllViewsLink() {
  return useLinkOnSameProject('/logs/views');
}
